import { render } from "./EditSalaryComponent.vue?vue&type=template&id=31d2320c&scoped=true"
import script from "./EditSalaryComponent.vue?vue&type=script&lang=js"
export * from "./EditSalaryComponent.vue?vue&type=script&lang=js"

import "./EditSalaryComponent.vue?vue&type=style&index=0&id=31d2320c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d2320c"]])

export default __exports__